import React from "react";
import { ColumnsType } from "antd/es/table";
import { Button, Input, Select } from "antd";
import Icons from "assets/icons";
import { ColumnsEdit } from "types/models/column-table-edit";
import { FIELD_TYPE } from "types/enums";
const { INPUT, SELECT, DATE } = FIELD_TYPE;

const columns: ColumnsEdit = [
  // {
  //   title: "STT",
  //   dataIndex: "stt",
  //   key: "stt",
  //   width: '4%',
  //   align: 'center',
  //   render: (text, record, index) => index + 1,
  // },
  {
    title: "Tên chỉ số",
    dataIndex: "tenXetNghiem",
    key: "tenXetNghiem",
    width: "25%",
    // type: INPUT,
  },
  {
    title: "Giá trị",
    dataIndex: "giaTri",
    key: "giaTri",
    width: "10%",
    align: "center",
    // type: INPUT,
  },
  {
    title: "Chỉ số bình thường",
    dataIndex: "giaTriBinhThuong",
    key: "giaTriBinhThuong",
    align: "center",
    // width: '4%',
    // type: INPUT,
  },
  {
    title: "Đơn vị tính",
    dataIndex: "donViTinh",
    key: "donViTinh",
    align: "center",
    // width: '4%',
    // type: INPUT,
  },
  {
    title: "Lần chạy",
    dataIndex: "lanChay",
    key: "lanChay",
    width: "10%",
    align: "center",
    // type: INPUT,
  },
  // {
  //   title: "",
  //   dataIndex: "action",
  //   key: "action",
  //   align: 'center',
  // },
];

const resultOptionAnalysis = [
  {
    name: "HBsAg test nhanh",
    option: [{ value: "Âm tính" }, { value: "Dương tính" }],
  },
  {
    name: "HIV Ab test nhanh",
    option: [{ value: "Âm tính" }, { value: "Dương tính" }],
  },
  {
    name: "UBG (UROBILINOGEN)",
    option: [
      { value: "Normal" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
    ],
  },
  {
    name: "BIL ( BILIRUBIN )",
    option: [
      { value: "Negative" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
    ],
  },
  {
    name: "KET ( KETONE )",
    option: [
      { value: "Negative" },
      { value: "±" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
      { value: "++++" },
    ],
  },
  {
    name: "BLD ( BLOOD )",
    option: [
      { value: "Negative" },
      { value: "±" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
      { value: "++++" },
    ],
  },
  {
    name: "PRO ( PROTEIN )",
    option: [
      { value: "Negative" },
      { value: "±" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
      { value: "++++" },
    ],
  },
  {
    name: "NIT (NITRITE )",
    option: [{ value: "Negative" }, { value: "Positive" }],
  },
  {
    name: "LEU ( LEUKOCYTES )",
    option: [
      { value: "Negative" },
      { value: "±" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
    ],
  },
  {
    name: "GLU ( GLUCOSE )",
    option: [
      { value: "Negative" },
      { value: "+" },
      { value: "++" },
      { value: "+++" },
      { value: "++++" },
    ],
  },
  {
    name: "SG ( SPECIFIC GRAVITY )",
    option: [
      { value: "1.000" },
      { value: "1.005" },
      { value: "1.010" },
      { value: "1.015" },
      { value: "1.020" },
      { value: "1.025" },
      { value: "1.030" },
    ],
  },
  {
    name: "pH",
    option: [
      { value: "5.0" },
      { value: "6.0" },
      { value: "6.5" },
      { value: "7.0" },
      { value: "7.5" },
      { value: "8.0" },
      { value: "8.5" },
    ],
  },
];

export { columns, resultOptionAnalysis };
